<template>
  <span v-if="mobile" class="font-size-14px">
    {{ currentItinerary.segments[0].departure.iataCode }} -
    {{
      currentItinerary.segments[
        currentItinerary.segments.length - 1
      ].arrival.iataCode
    }}
  </span>
  <span v-else class="d-flex" style="gap: 8px">
    <span class="thin font-size-14px">
      Volo {{ currentSegmentIndex + 1 }} / {{ totalSegments }}:
    </span>
    <span
      v-if="segment"
      class="font-size-16px"
    >
      {{ locations[segment.departure.iataCode].name }}
      -
      {{ locations[segment.arrival.iataCode].name }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'FlightSegmentDisplay',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    currentSegmentIndex: Number,
    totalSegments: Number,
    segment: Object,
    currentItinerary: Object,
    locations: Object,
  },
}
</script>
